import React from 'react';
import {Button as RNEButton,ButtonProps} from '@rneui/themed';

const Button = (props: ButtonProps) => (
  <RNEButton
    radius={'sm'}
    size="sm"
    {...props}
    buttonStyle={[
      {
        width: 200,
        alignSelf: 'center',
      },
      props.buttonStyle,
    ]}
  />
);

export default Button;
